import Marionette from 'lib/marionette'
import template from 'templates/login'

import AppMetadata from 'metadata'

import Auth from 'lib/auth'

import Debug from 'debug'
const debug = Debug('pandore:views:login')

const ERROR_MAP = {
	ERROR: 'Server Error.',
	AUTHENTICATION_FAILED: 'Invalid login or password.',
}

const LoginView = Marionette.View.extend({
	template: template,
	className: 'login',

	ui: {
		usernameInput: '#usernameInput',
		passwordInput: '#passwordInput',
		messageZone: '.messageZone',

		allControls: 'input, button',
		submitButton: '.submitButton',
		spinnerButton: '#spinnerButton',
	},

	events: {
		'submit form': 'handleFormSubmit',
	},

	initialize() {
		debug('Initializing LoginView:',this.options)
	},

	templateContext() {
		return {AppMetadata}
	},

	onRender() {
		this.disable(false)
	},

	disable(flag) {
		flag ??= true
		this.ui.allControls.setDisabled(flag)
		this.ui.submitButton.toggle(!flag)
		this.ui.spinnerButton.toggle(flag)

	},

	async handleFormSubmit(event) {
		debug('Form submitted')
		this.ui.messageZone.empty()
		this.disable()

		try {
			await Auth.login(this.ui.usernameInput.val(),this.ui.passwordInput.val())
		} catch(err) {
			this.disable(false)
			console.error('Login error:',err)
			this.ui.messageZone.text(ERROR_MAP[err] || err)
			this.ui.passwordInput.focus().select()
		}
	},
})

export default LoginView
